import { useTranslation } from "../../hooks/useTranslation";
import { Tabs, Tab, Container } from "react-bootstrap";
import { FaDumbbell, FaUsers, FaTags } from "react-icons/fa";
import { motion } from "framer-motion";

const categoryIcons = {
  adult: <FaDumbbell />,
  discount: <FaTags />,
  group: <FaUsers />
};

export default function Prices(promps) {
  const t = useTranslation();
  const sections = t("pricelist.sections");
  const footer = t("pricelist.footer");
  const tabKeys = ["adult", "discount", "group"];

  const fadeUp = i => ({
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { delay: i * .05, duration: .4 } }
  });

  return (

    <div className="price-list-dark-wrapper">
      <motion.div
        variants={fadeUp(promps.motionOrder)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-50px" }}
      >
        <Container>
          <div className="zoom-wrapper">
            <div className="glass-wrapper shadow">
              <Tabs defaultActiveKey="adult" id="pricelist-tabs" className="-flex justify-content-around mb-4" >
                {tabKeys.map((key) => {
                  const section = sections[key];
                  return (
                    <Tab
                      eventKey={key}
                      title={
                        <span className="d-flex align-items-center gap-2">
                          <span className="glass-icon text-warning">{categoryIcons[key]}</span>
                          {section.title}
                        </span>
                      }
                      key={key}
                    >
                      <ul className="list-unstyled mt-3">
                        {section.items?.map((item, idx) => (
                          <li key={idx} className="price-item border-bottom mb-4 pb-4">
                            <div className="d-flex justify-content-between fw-semibold">
                              <span>{item.name}</span>
                              <span className="text-warning">{item.price}</span>
                            </div>
                            <small className="desc d-block mt-1">{item.desc}</small>
                          </li>
                        ))}
                      </ul>

                      {section.note && (
                        <div className="section-notes mt-3">
                          {section.note.map((note, i) => (
                            <p key={i} className="fst-italic small text-warning">⚠ {note}</p>
                          ))}
                        </div>
                      )}
                    </Tab>
                  );
                })}
              </Tabs>

              <div className="footer-wrapper text-center">
                <p className="footer-note">{footer}</p>
              </div>
            </div>
          </div>
        </Container>
      </motion.div>
    </div >
  );
}

